import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';

export function getProductSearchReqObj(versionId: string): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export function getInventoryList(
  versionId?: string,
  itemNumber?: string,
  language?: string,
  countryCode?: string,
  channel?: string,
  vertical?: string,
): RequestOptions {
  return {
    url: `/comproductas/${versionId}/inventories/${itemNumber}`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      'X-Amway-Tenant': '200',
      ...(language && { 'Accept-Language': language }),
      ...(countryCode && { 'X-Amway-Country': countryCode }),
      ...(channel && { 'X-Amway-Channel': channel }),
      ...(vertical && { 'X-Amway-Vertical': vertical }),
    },
    retries: 0,
  };
}

export function getProductByProductIdOrItemCode(
  versionId: string,
  language?: string,
  channel?: string,
): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      ...(language ? { 'Accept-Language': language } : { 'Accept-Language': '*' }),
      ...(channel && { 'X-Amway-Channel': channel }),
    },
    retries: 0,
  };
}

export function getRedirectionLinkForContentStack(
  versionId: string,
  productId: string,
  language?: string,
  channel?: string,
): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products/${productId}/pcm-metadata`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      ...(language && { 'Accept-Language': language }),
      ...(channel && { 'X-Amway-Channel': channel }),
    },
    retries: 0,
  };
}

export function getPriceList(
  versionId: string,
  productId: string,
  itemNumber: string,
  countryCode?: string,
  language?: string,
  channel?: string,
): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products/${productId}/items/${itemNumber}`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      ...(countryCode && { 'X-Amway-Country': countryCode }),
      ...(language && { 'Accept-Language': language }),
      ...(channel && { 'X-Amway-Channel': channel }),
    },
    retries: 0,
  };
}

export function getChannelList(versionId: string, language?: string): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      'X-Amway-Channel': '*',
      ...(language && { 'Accept-Language': language }),
    },
    retries: 0,
  };
}

export function publishChannel(versionId: string, productId: string): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products/${productId}`,
    method: HTTPVerbs.PATCH,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export function duplicateChannel(versionId: string, productId: string, language?: string): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products/${productId}`,
    method: HTTPVerbs.POST,
    headers: {
      'Content-Type': 'application/json',
      ...(language && { 'Accept-Language': language }),
    },
    retries: 0,
  };
}

export function getCategoryList(versionId: string, language?: string, channel?: string): RequestOptions {
  return {
    url: `/comcategoryas/${versionId}/categories`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      ...(language && { 'Accept-Language': language }),
      ...(channel && { 'X-Amway-Channel': channel }),
    },
    retries: 0,
  };
}

export function categoryOverview(versionId: string, category: string): RequestOptions {
  return {
    url: `/comcategoryas/${versionId}/categories/${category}`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export function subCategory(versionId: string, category: string): RequestOptions {
  return {
    url: `/comcategoryas/${versionId}/categories/${category}/children`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export default {
  getProductSearchReqObj,
  getRedirectionLinkForContentStack,
  getProductByProductIdOrItemCode,
  getPriceList,
  getChannelList,
  publishChannel,
  duplicateChannel,
  getCategoryList,
  categoryOverview,
  subCategory,
  getInventoryList,
};
